import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { identity } from "../../../utils/getIdentity";
import { ReactComponent as CloseSVG } from '../../../img/default-svg/close-black.svg';
import './style.scss';
import Button from "../../Button";
import '../../../layout/Modal.scss';
import { useTranslation } from "react-i18next";

const DeactivatePlan = ({ visible, close, currentValues, changePlan }) => {
  const { t } = useTranslation();
  return (
    <Modal
      width={520}
      title=""
      visible={visible}
      onCancel={close}
      footer={null}
      className={`checkout-modal checkout-modal-${identity}`}
      centered
      closeIcon={<CloseSVG />}
      destroyOnClose
      maskClosable={false}
    >
      <div className={`checkout-modal-content checkout-modal-content-${identity}`}>
        <div className={`checkout-modal-content__titlePlan checkout-modal-content__titlePlan-${identity}`}>
          {t('admin.deactivate_plan')}
        </div>
        <div className={`checkout-modal-content__subtitle checkout-modal-content__subtitle-${identity}`}>
          {t('admin.you_have')} {currentValues?.activeSubscriptions} {t('admin.active_subscription')}
        </div>
        <div className="checkout-modal-content__body">
          <div className="checkout-modal-content__body--button">
            <Button onClick={close} type="secondary">{t('admin.back')}</Button>
            <Button onClick={() => changePlan(false, currentValues?.published)} type="danger">Deactivate Plan</Button>
          </div>
        </div>
      </div>
    </Modal>
  )
};

export default DeactivatePlan;